import { render } from "./addpage.vue?vue&type=template&id=41cd9a37&scoped=true"
import script from "./addpage.vue?vue&type=script&lang=js"
export * from "./addpage.vue?vue&type=script&lang=js"

import "./addpage.vue?vue&type=style&index=0&id=41cd9a37&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cd9a37"]])

export default __exports__